import React, { FC, useMemo, useState } from 'react';
import orderBy from 'lodash/orderBy';
import { SloQualityResultItemDTO } from '@atlassiansox/phobos-client-ts';

import {
  scrollStyles,
  spaceTopComfortable,
  tableRowsStyles,
  tableScrollableHeadStyles,
} from '@/styles';

import * as styles from './styles';
import { SloQualityResultItemDisplayType, QualityScoreCheckProps } from './types';
import QualityScoreCheckResultItem from './quality-score-check-result-item';
import { testIds } from './constants';

const QualityScoreCheckResults: FC<QualityScoreCheckProps> = ({ quality, refSummary }) => {
  const [expandedItemId, setExpandedItemId] = useState<string>('');

  const items: SloQualityResultItemDisplayType[] = useMemo(
    () =>
      orderBy(
        quality?.sloQualityResultItems,
        ['qualityScore', item => (item?.metaData?.warning ? 0 : 1), 'qualityCheckerId'],
        ['asc', 'asc', 'asc']
      ).map((item: SloQualityResultItemDTO) => ({
        ...item,
        title: item.qualityCheckerId.replace(/\_/g, ' ').toLowerCase(),
      })),
    [quality]
  );

  if (!quality || !quality.sloQualityResultItems?.length) return <></>;

  return (
    <div css={spaceTopComfortable}>
      <div css={[tableScrollableHeadStyles, styles.resultRowStyles]}>
        <div>Quality Check Item</div>
        <div>Score</div>
        <div>Severity</div>
        <div>Check Result</div>
        <div>Guideline</div>
      </div>
      <ul
        css={[tableRowsStyles, scrollStyles, styles.resultsScrollStyles]}
        data-testid={testIds.qualityScoreCheckResults}
      >
        {items.map((item: SloQualityResultItemDisplayType) => (
          <QualityScoreCheckResultItem
            // eslint-disable-next-line react/jsx-props-no-spreading
            result={item}
            key={item.publicId}
            refSummary={refSummary}
            expanded={expandedItemId === item.publicId}
            onExpand={(id: string) => {
              setExpandedItemId(id);
            }}
          />
        ))}
      </ul>
    </div>
  );
};

export default QualityScoreCheckResults;
